
import { Component, Mixins, Watch, Vue } from 'vue-property-decorator';
import ModelMixin from '@/mixins/ModelMixin';
import ValidateableMixin from '@/mixins/ValidateableMixin';
import { Action } from 'vuex-class';
import { actions } from '@/store/types';
import { UpdatePasswordActionType } from '@/types/store/actions';
import rules from '@/utils/validation-rules';
import { passwordValidationDescription } from '@/constants/constants';

@Component({
    components: {},
    mixins: [ModelMixin, ValidateableMixin],
})
export default class PasswordPopup extends Mixins<ValidateableMixin, ModelMixin<boolean>>(
    ValidateableMixin,
    ModelMixin,
) {
    passwordValidationDescription = passwordValidationDescription;

    passwordViewType = {
        oldPasswordType: 'password',
        newPasswordType: 'password',
        confirmNewPasswordType: 'password',
    };

    oldPassword = '';
    password = '';
    confirmation = '';

    get requiredRules() {
        return [rules.required('This field is required')];
    }

    get passwordRules() {
        return [
            rules.required('This field is required'),
            () => {
                // console.log(`>>> this.password = "${this.password}", this.confirmation = "${this.confirmation}"`);
                return this.password === this.confirmation || 'Password and confirmation must match';
            },
        ];
    }

    @Action(actions.UPDATE_PASSWORD)
    updatePassword!: UpdatePasswordActionType;

    async save(e: Event) {
        e.preventDefault();
        if (this.password != this.confirmation) {
            Vue.toasted.error(`New password dosn't match with confirmation`);
            return;
        }
        // if (!this.validate()) {
        //     return;
        // }
        const result = await this.updatePassword({
            oldPassword: this.oldPassword,
            password: this.password,
            confirmation: this.confirmation,
        });

        if (result) {
            this.model = false;
        }
    }

    @Watch('model', { immediate: true })
    onModelChange(newValue: boolean, oldValue: boolean) {
        if (newValue && !oldValue) {
            this.oldPassword = '';
            this.password = '';
            this.confirmation = '';
        }
    }
}
